<div style="width: 100%" class="{{ highlightedCommentId === publication.id ? 'highlighted-card' : '' }}">
    <div
        class="custom-comment p-d-flex-column p-mt-1 mr-1"
        (mouseenter)="showEditPost = true"
        (mouseleave)="showEditPost = false"
        [ngClass]="{ 'sub-comment-ml': publicationHelper.isPublicationMaxDepth(publication) }"
        *ngIf="publication != null"
        id="{{ publication.id }}"
    >
        <div class="p-d-flex" (click)="setFocusOnPost()">
            <a class="profile-link" [routerLink]="['/directory/profile', publication.owner.id]" routerLinkActive="active" target="_blank">
                <p-avatar
                    styleClass="p-ml-1 avatar"
                    *ngIf="publication.owner"
                    [image]="publication.owner.pictureAccessLink"
                    size="large"
                    shape="circle"
                    [ngClass]="{ 'member-mentioned': isCurrentMemberMentioned() }"
                    [style]="{ 'background-color': 'var(--gray-light)' }"
                    [label]="
                        !publication.owner.pictureAccessLink ? publication.owner.firstName.slice(0, 1) + publication.owner.lastName.slice(0, 1) : ''
                    "
                ></p-avatar>
            </a>
            <div class="p-flex-column p-ml-2">
                <div class="p-d-flex">
                    <div class="d-flex flex-column custom-comment-card p-py-2 p-px-3 pr-4">
                        <div class="p-d-flex">
                            <a
                                class="profile-link"
                                [routerLink]="['/directory/profile', publication.owner.id]"
                                routerLinkActive="active"
                                target="_blank"
                            >
                                <div class="p-d-flex user-names comment-owner-infos">
                                    {{ publication.owner.firstName }}
                                    {{ publication.owner.lastName }}
                                    <span class="comment-owner-role" *ngIf="postOwnerRole == clubRoles.Admin">- Admin</span>
                                    <span class="comment-owner-role" *ngIf="postOwnerRole == clubRoles.Animator">- Animateur</span>
                                </div>
                            </a>

                            <div class="edit-gear">
                                <app-gear-edit-post
                                    [publication]="publication"
                                    [parentPublicationId]="parentPublicationId"
                                    [showEditPost]="showEditPost"
                                    (onPublicationDeleted)="onPublicationDeleted()"
                                    (onPublicationUpdated)="onPublicationUpdated($event)"
                                ></app-gear-edit-post>
                            </div>
                        </div>
                        <div class="comment-content" *ngIf="!isContentEmpty(publication.content)" [innerHTML]="sanitizedContent"></div>
                    </div>
                </div>

                <div class="p-d-flex comment-picture p-my-1" *ngIf="publication != null && publication.pictureAccessLink != null">
                    <img [src]="publication.pictureAccessLink" class="comment-picture-media" (click)="onClickOnPicture()" />

                    <app-modal-publication-picture
                        *ngIf="publication.pictureAccessLink != null"
                        [pictureAccessLink]="publication.pictureAccessLink"
                    ></app-modal-publication-picture>
                </div>
                <app-modal-publication-reactions-details
                    *ngIf="publication.reactionsDetails != null"
                    [membersAssociatedToReactions]="membersAssociatedToReactions"
                    [reactionTypes]="reactionTypes"
                ></app-modal-publication-reactions-details>
                <div class="p-d-flex p-flex-wrap p-ml-2 p-my-1 custom-comment-others-tools">
                    <div (click)="getPostReactionsDetails()" class="p-d-flex existing-reaction-items">
                        <div class="club-several-infos" *ngFor="let reaction of publication.reactions | keyvalue">
                            <span *ngIf="reaction.value > 0" class="p-mr-1">
                                {{ getReactionTypeCode(reaction.key) }}
                                {{ reaction.value }}
                            </span>
                        </div>
                    </div>

                    <div class="p-d-flex p-ml-1 club-several-infos" *ngIf="hasReaction">
                        <span>•</span>
                    </div>
                    <div class="p-d-flex p-ml-1" *ngIf="!publication.disabled">
                        <div class="comment-new-custom-reaction">
                            <app-add-new-reaction
                                (mouseenter)="hoverOnAddCustomReaction = true"
                                (mouseleave)="hoverOnAddCustomReaction = false"
                                *ngIf="hoverOnLike || hoverOnAddCustomReaction"
                                (onReactionAdded)="addOrRemoveReaction($event)"
                            ></app-add-new-reaction>
                        </div>

                        <span
                            (click)="addOrRemoveReaction(reactionTypes[0].id)"
                            class="highlightable-infos club-several-infos"
                            (mouseenter)="hoverOnLike = true"
                            (mouseleave)="disableHoverOnLike()"
                        >
                            {{ 'clubs.page.common.card.like' | translate }}</span
                        >
                    </div>
                    <div class="p-d-flex p-ml-1 club-several-infos" *ngIf="!publication.disabled">
                        <span>•</span>
                    </div>
                    <div class="p-d-flex p-ml-1" *ngIf="!publication.disabled">
                        <span (click)="showAddNewComment()" class="highlightable-infos club-several-infos">
                            {{ 'clubs.page.common.card.answer' | translate }}</span
                        >
                    </div>
                    <div class="p-d-flex p-ml-1 club-several-infos" *ngIf="!publication.disabled">
                        <span>•</span>
                    </div>
                    <div class="p-d-flex p-ml-1 club-several-infos">
                        <span>
                            {{ publication.creationDate | dateAgo }}
                        </span>
                    </div>
                    <div
                        class="p-d-flex p-ml-1 club-several-infos"
                        *ngIf="!publicationHelper.isPublicationMaxDepth(publication) && publication.hasComments"
                    >
                        <span>•</span>
                    </div>
                    <div
                        class="p-d-flex p-ml-1 highlightable-infos club-several-infos"
                        (click)="toogleCommentsDisplay()"
                        *ngIf="!publicationHelper.isPublicationMaxDepth(publication) && publication.hasComments"
                    >
                        {{
                            publication.commentsCount
                                | i18nPlural
                                    : {
                                          '=1': 'clubs.page.common.card.count.one' | translate,
                                          other: 'clubs.page.common.card.count.x' | translate
                                      }
                        }}
                    </div>
                </div>
            </div>
        </div>

        <div class="p-d-flex-column">
            <div (click)="setFocusOnPost()">
                <div
                    class="load-other-comments p-mt-2 p-mb-2 p-ml-2"
                    *ngIf="publication.commentsCount > 0 && publication.commentsCount > comments.length"
                    (click)="getComments()"
                >
                    <span
                        *ngIf="
                            page === 1 &&
                            publication.commentsCount < commentsPageSizes.commentsPageSize &&
                            publication.commentsCount > commentsPageSizes.previewCommentsPageSize
                        "
                    >
                        Voir
                        {{
                            publication.commentsCount - 2
                                | i18nPlural
                                    : {
                                          '=1': 'clubs.page.common.card.postCommentCount.one' | translate,
                                          other: 'clubs.page.common.card.postCommentCount.x' | translate
                                      }
                        }}
                    </span>
                    <span *ngIf="comments.length < publication.commentsCount && publication.commentsCount > commentsPageSizes.commentsPageSize">
                        {{ 'clubs.page.common.card.seeMore' | translate : { length: comments.Length, count: publication.commentsCount } }}
                    </span>
                </div>
            </div>
            <app-comment-card
                class="p-d-flex"
                *ngFor="let comment of comments"
                [publication]="comment"
                [parentPublicationId]="parentPublicationId"
                [highlightedCommentId]="highlightedCommentId"
                (onCommentDeleted)="onCommentDeletedFunction()"
                (onCommentCreated)="onAddNewComment($event)"
                (onClickOnAddNewAnswer)="onClickOnAddNewAnswerFunction(comment.owner)"
            ></app-comment-card>
        </div>

        <div class="p-d-flex-column p-ml-6" (click)="setFocusOnPost()">
            <div *ngIf="hasSignalrFocus && peopleWrittingCommentCount > 0" class="p-ml-6">
                {{ 'clubs.page.common.card.typing' | translate }}
            </div>
        </div>

        <div
            *ngIf="publication !== null && !publication.disabled && !publicationHelper.isPublicationMaxDepth(publication) && shouldShowAddNewComment"
            class="p-d-flex p-ml-6"
            (click)="setFocusOnPost()"
        >
            <app-add-new-comment
                [publication]="publication"
                (onCommentCreated)="onAddNewComment($event)"
                #addNewComment
                style="width: 100%"
            ></app-add-new-comment>
        </div>
    </div>
</div>
